<template>
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
  >
    <path
      d="M6.63815 2.73056C6.53886 2.68939 6.42999 2.66666 6.31581 2.66666C6.20163 2.66666 6.09276 2.68939 5.99347 2.73056C5.89414 2.77166 5.80109 2.83257 5.72035 2.91331L2.91333 5.72033C2.58447 6.04919 2.58447 6.58238 2.91333 6.91124C3.2422 7.24011 3.77539 7.24011 4.10425 6.91124L5.4737 5.54179V10.2456C5.4737 11.0645 5.79902 11.8499 6.37808 12.429C6.95714 13.008 7.74251 13.3333 8.56142 13.3333H12.4912C12.9563 13.3333 13.3334 12.9563 13.3334 12.4912C13.3334 12.0261 12.9563 11.6491 12.4912 11.6491H8.56142C8.18919 11.6491 7.8322 11.5013 7.56899 11.238C7.30578 10.9748 7.15791 10.6178 7.15791 10.2456V5.54179L8.52737 6.91124C8.85623 7.24011 9.38942 7.24011 9.71829 6.91124C10.0471 6.58238 10.0471 6.04919 9.71829 5.72033L6.91127 2.91331C6.83053 2.83257 6.73748 2.77166 6.63815 2.73056Z"
    />
  </svg>
</template>
